export function displayTax(rate) {
  let result = rate * 100;
  result = parseFloat(result.toFixed(12));
  result = result.toString().replace(/\.?0+$/, '');

  return result + '%'
}
